import {EditPresenter} from "../../routing/EditPresenter";
import * as ViewMode from "../../constants/ViewMode";
import {EditPlace} from "../../routing/places";
import {NamaKendoWindow, NamaWindowBtnData} from "../NamaKendoWindow";
import * as ts from "../../common/Translator";
import * as NamaURLS from "../../constants/NamaURLS";
import {ajaxJSON} from "../../common/NamaCommon";

export class PopupQuickCreator {
    constructor(newObject, contextInfo, callBack, requesterType, tabId, event) {
        let that = this;
        that.entityType = newObject.entityType;
        that.newObject = newObject;
        that.contextInfo = contextInfo;
        that.callBack = callBack;
        that.requesterType = requesterType;
        that.tabId = tabId;
        that.event = event;
    }

    show() {
        let that = this;
        let editPlace = new EditPlace();
        editPlace.entityType = that.entityType;
        editPlace.view = ViewMode.NEW;
        editPlace.pageId = that.tabId;
        if (that.newObject != null) {
            editPlace.createdObject = that.newObject;
            if (that.newObject.commitedBefore)
                editPlace.view = ViewMode.EDIT;
        }
        editPlace.quickCreate = true;
        editPlace.quickCreateContextInfo = that.contextInfo;
        editPlace.quickCreateRequester = that.requesterType;
        if (that.event && that.event.ctrlKey)
            window.open(editPlace.fullLink(), "_blank");
        else
            startPopup(editPlace, that.callBack, true);
    }
}

export function startPopup(editPlace, callBack, quickCreator) {
    let editPresenter = new EditPresenter(editPlace);
    let okBtnData = new NamaWindowBtnData("ok");
    let cancelBtnData = new NamaWindowBtnData("cancel");
    let window = new NamaKendoWindow(ts.translateId(editPlace.entityType), okBtnData, cancelBtnData);
    let successCallBack = quickCreator ? (record) => {
        ajaxJSON(NamaURLS.FIND_REF_BY_ID, {
            entityType: record.entityType,
            id: record.id
        }, (ref) => {
            window.closeWindow();
            if (callBack)
                callBack(ref);
        })
    } : null;
    okBtnData.btnAction = () => editPresenter.saveQuickCreatedObject(successCallBack);
    cancelBtnData.btnAction = (e) => {
        if (editPresenter.navigationNotConfirmed()) {
            e.preventDefault();
            return;
        }
        window.window.data("kendoWindow").destroy()
    };
    editPresenter.simpleEntityContainer = window.content;
    editPresenter.start();
    window.fullScreen = true;
    window.showWindow();

}